import IconButton from '@/features/ui/buttons/components/IconButton'
import MapIcon from '@/features/ui/icons/components/MapIcon'
import { FC } from 'react'

interface MapButtonProps {
    onPress: () => void
    accessibilityLabel: string
}

const MapButton: FC<MapButtonProps> = ({ onPress, accessibilityLabel }) => (
    <IconButton
        Icon={MapIcon}
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel}
        size={40}
        type="default"
    />
)

export default MapButton
